module.exports = __webpack_public_path__ + "img/hot_brand.597f5735.png";